// extracted by css-extract-rspack-plugin
module.exports =  {"container":"List-Wy64__container","spinner":"List-eDXD__spinner","save-container":"List-FC5s__save-container","synonyms":"List-lp1U__synonyms"};